import { render } from "./EditAmenity.vue?vue&type=template&id=393e5620"
import script from "./EditAmenity.vue?vue&type=script&lang=js"
export * from "./EditAmenity.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__